import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { addPurchasedClaps } from '../utils/clapManagerV2';
import ClapRefillTimer from './ClapRefillTimer';

function ClapRefillModal({ isOpen, onClose }) {
  const { currentUser } = useAuth();
  const [isWatchingAd, setIsWatchingAd] = useState(false);
  
  console.log('ClapRefillModal rendered with props:', { isOpen, currentUser: currentUser?.uid });
  
  if (!isOpen) return null;
  
  console.log('ClapRefillModal rendering with isOpen:', isOpen);
  
  const handleWatchAd = () => {
    setIsWatchingAd(true);
    
    // Simulate watching an ad for 5 seconds
    setTimeout(() => {
      // Give user 5 free claps
      const userId = currentUser?.uid || 'anonymous_user';
      addPurchasedClaps(userId, 5);
      
      setIsWatchingAd(false);
      onClose();
      
      // Show success message
      alert('You received 5 free claps! 👏');
    }, 5000);
  };
  
  const handlePurchase = (amount, price) => {
    // In a real app, this would integrate with a payment system
    alert(`Purchase ${amount} claps for ${price} - Payment integration coming soon!`);
  };
  
  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 100000
      }}
      onClick={(e) => {
        console.log('ClapRefillModal overlay clicked');
        if (e.target === e.currentTarget) {
          console.log('Clicked outside modal content, closing modal');
          onClose();
        }
      }}
    >
      <div style={{
        backgroundColor: '#1a1a1a',
        borderRadius: '20px',
        padding: '30px',
        maxWidth: '450px',
        width: '90%',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.5)',
        color: 'white',
        border: '3px solid red' // DEBUG: Make modal content visible
      }}>
        <h2 style={{
          fontSize: '24px',
          marginBottom: '20px',
          textAlign: 'center',
          color: '#4CAF50'
        }}>
          Out of Claps! 👏
        </h2>
        
        {/* Daily refill timer */}
        <ClapRefillTimer />
        
        <p style={{
          textAlign: 'center',
          marginBottom: '25px',
          fontSize: '16px',
          opacity: 0.9
        }}>
          Get more claps to show appreciation for great comments!
        </p>
        
        {/* Watch Ad Option */}
        <button
          onClick={handleWatchAd}
          disabled={isWatchingAd}
          style={{
            width: '100%',
            padding: '15px',
            marginBottom: '15px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '10px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: isWatchingAd ? 'not-allowed' : 'pointer',
            opacity: isWatchingAd ? 0.7 : 1,
            transition: 'all 0.3s ease'
          }}
        >
          {isWatchingAd ? 'Watching Ad... ⏳' : 'Watch Ad for 5 Free Claps 📺'}
        </button>
        
        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          marginTop: '20px',
          paddingTop: '20px'
        }}>
          <h3 style={{
            fontSize: '18px',
            marginBottom: '15px',
            color: '#4CAF50'
          }}>
            Purchase Clap Packs
          </h3>
          
          {/* Purchase Options */}
          <div style={{ display: 'grid', gap: '10px' }}>
            <button
              onClick={() => handlePurchase(10, '$0.99')}
              style={{
                padding: '12px',
                backgroundColor: 'rgba(76, 175, 80, 0.2)',
                color: 'white',
                border: '1px solid #4CAF50',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <span>10 Claps</span>
              <span style={{ fontWeight: 'bold' }}>$0.99</span>
            </button>
            
            <button
              onClick={() => handlePurchase(50, '$3.99')}
              style={{
                padding: '12px',
                backgroundColor: 'rgba(76, 175, 80, 0.2)',
                color: 'white',
                border: '1px solid #4CAF50',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <span>50 Claps</span>
              <span style={{ fontWeight: 'bold' }}>$3.99</span>
            </button>
            
            <button
              onClick={() => handlePurchase(100, '$6.99')}
              style={{
                padding: '12px',
                backgroundColor: 'rgba(76, 175, 80, 0.2)',
                color: 'white',
                border: '1px solid #4CAF50',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <span>100 Claps</span>
              <span style={{ fontWeight: 'bold' }}>$6.99</span>
            </button>
            
            <button
              onClick={() => handlePurchase(500, '$24.99')}
              style={{
                padding: '12px',
                background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontWeight: '600'
              }}
            >
              <span>500 Claps 🎉</span>
              <span>$24.99</span>
            </button>
          </div>
        </div>
        
        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '12px',
            marginTop: '20px',
            backgroundColor: 'transparent',
            color: '#888',
            border: '1px solid #444',
            borderRadius: '8px',
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
}

export default ClapRefillModal;